import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/auth");
      return;
    }
    (async () => {
      try {
        const { data } = await api.post(
          "/auth/session",
          {},
          { headers: { "X-Session-ID": sessionId } },
        );
        setUser(data.user);
        toast.success(`Welcome, ${data.user.name.split(" ")[0]}.`);
        // Clean hash
        window.history.replaceState({}, "", "/account");
        navigate("/account", { state: { user: data.user } });
      } catch (e) {
        toast.error("Could not complete sign in.");
        navigate("/auth");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div
      data-testid="auth-callback-page"
      className="min-h-[60vh] flex items-center justify-center"
    >
      <div className="text-muted-bone overline">Signing you in…</div>
    </div>
  );
};

export default AuthCallback;
